
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class PackageDescriptionItems extends Vue {
  @Prop({ type: Array, default: [] }) displayDescriptionItems!: string[]
}
